export default class ClinicalHistoryDocument {
    public readonly key?: string;
    public readonly location?: string;
    public readonly valid?: boolean;
    public readonly details?: Record<string, any>;
    public readonly date?: Date;
    public readonly deleted?: boolean;
    private readonly _name?: string;

    constructor({
        key,
        location,
        valid,
        details,
        name,
        date,
        deleted,
    }: {
        key?: string;
        location?: string;
        valid?: boolean;
        details?: Record<string, any>;
        name?: string;
        date?: Date;
        deleted?: boolean;
    }) {
        this.key = key;
        this.location = location;
        this.valid = valid;
        this.details = details;
        this._name = name;
        this.date = date;
        this.deleted = deleted;
    }

    get name(): string {
        const locationFileName = this.location?.split('/').pop();
        return this._name ?? locationFileName ?? this.key ?? 'NA';
    }
}
